import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4dde8d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    id: "poi_gallery",
    class: _normalizeClass({ no_results: !_ctx.filteredPois.length })
  }, [
    _createElementVNode("header", null, [
      (_ctx.filteredPois.length)
        ? (_openBlock(), _createElementBlock("strong", _hoisted_1, _toDisplayString(_ctx.t("poi_gallery.header", { type: _ctx.insightTitle })), 1))
        : (_openBlock(), _createElementBlock("strong", _hoisted_2, _toDisplayString(_ctx.t("poi_gallery.no_results", { type: _ctx.insightTitle })), 1)),
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close())),
        class: "k-icon k-i-close"
      })
    ]),
    (_ctx.filteredPois.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPois, (poi, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              onClick: ($event: any) => (_ctx.showPOI(poi)),
              class: "poi"
            }, [
              _createElementVNode("img", {
                src: _ctx.calcImageURL(poi)
              }, null, 8, _hoisted_5)
            ], 8, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_vShow, _ctx.isShow]
  ])
}